// extracted by mini-css-extract-plugin
module.exports = {"main":"privacyPolicyPage_main__kYr8J"};